<template>
  <node-view-wrapper class="igi" contenteditable="false">
    <img :src="node.attrs.src" style="max-height: 200px; display: block" />

    <div class="igi__controls">
      <v-icon color="white" @click="onCloseClick">
        mdi-close
      </v-icon>
    </div>
  </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";

export default {
  components: {
    NodeViewWrapper
  },
  props: nodeViewProps,
  methods: {
    onCloseClick() {
      this.deleteNode();
    }
  }
};
</script>

<style lang="scss" scoped>
.igi {
  background: #fff;
  border: 1px solid #0d0d0d;
  margin: 8px;
  position: relative;
  flex-grow: 0;
  max-width: 300px;

  .igi__controls {
    position: absolute;
    right: 0;
    top: 0;
    background-color: rgba(100, 100, 100, 0.5);
    display: none;
  }

  &:hover {
    .igi__controls {
      display: flex;
    }
  }
}
</style>
